import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01bcded2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content time" };
const _hoisted_2 = { class: "content other" };
const _hoisted_3 = { class: "content other" };
const _hoisted_4 = { class: "content amount" };
const _hoisted_5 = { class: "content action" };
const _hoisted_6 = { class: "content cancel_cont" };
const _hoisted_7 = {
    key: 0,
    class: "cancel"
};
const _hoisted_8 = ["onClick"];
import { decimalize, decimalizeByExchange, setTimezone } from '@/logics/utils';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import NoData from '@/materials/atoms/NoData.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: null
    },
    emits: ["showModal"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, OPEN_ORDERS_FIELDS } = useMessage();
        const onCancel = (order) => {
            emit('showModal', order);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "list",
                        key: index
                    }, [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), item.time, 'YYYY-MM-DD HH:mm:ss')), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["content side", item.side])
                        }, _toDisplayString(item.side), 3),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(item.pair), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(item.price !== null
                            ? _unref(decimalizeByExchange)(item.price, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)
                            : '---'), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(item.amount !== null ? _unref(decimalize)(item.executed, _unref(store).getters.symbol.base, _unref(store).state.currencyInfo) : '---') + " / " + _toDisplayString(item.amount !== null ? _unref(decimalize)(item.amount, _unref(store).getters.symbol.base, _unref(store).state.currencyInfo) : '---'), 1),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.actions), 1),
                        _createElementVNode("div", _hoisted_6, [
                            (item.actions !== 'canceling')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("label", {
                                        class: "cancel",
                                        onClick: ($event) => (onCancel(item))
                                    }, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_FIELDS).CANCEL)), 9, _hoisted_8)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]));
                }), 128)),
                _createVNode(NoData, {
                    isShow: props.list.length === 0
                }, null, 8, ["isShow"])
            ]));
        };
    }
});
